import api from "../api";

export const getUsers = async () => {
  try {
    const response = await api.get("mivulite/users");
    return response.data;
  } catch (error) {
    console.error("Error fetching users:", error);
    throw error;
  }
};


export const addNewUser = async (userData) => {
  try {
    const response = await api.post(`mivulite/auth/register`, userData);
    return response.data;
  } catch (error) {
    console.error("Error adding user:", error);
    throw error;
  }
};


export const getPendingRegistrations = async () => {
  try {
    const response = await api.get("mivulite/users/pending/registrations");
    return response.data;
  } catch (error) {
    console.error("Error fetching pending registrations:", error);
    throw error;
  }
};


export const deleteUser = async (id) => {
  try {
    const response = await api.delete(`mivulite/users/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting user:", error);
    throw error;
  }
};


export const activateUser = async (id) => {
  try {
    const response = await api.put(`mivulite/users/${id}/activate`);
    return response.data;
  } catch (error) {
    console.error("Error activating user:", error);
    throw error;
  }
};


export const deactivateUser = async (id) => {
  try {
    const response = await api.put(`mivulite/users/${id}/deactivate`);
    return response.data;
  } catch (error) {
    console.error("Error deactivating user:", error);
    throw error;
  }
};


export const getUserDevices = async (id) => {
  try {
    const response = await api.get(`mivulite/users/${id}/devices`);
    return response.data;
  } catch (error) {
    console.error("Error fetching user devices:", error);
    throw error;
  }
};


export const assignDeviceToUser = async (id, deviceData) => {
  try {
    const response = await api.post(`mivulite/users/${id}/devices`, deviceData);
    return response.data;
  } catch (error) {
    console.error("Error assigning device to user:", error);
    throw error;
  }
};


export const unassignDeviceFromUser = async (id, deviceId) => {
  try {
    const response = await api.delete(`mivulite/users/${id}/devices/${deviceId}`);
    return response.data;
  } catch (error) {
    console.error("Error unassigning device from user:", error);
    throw error;
  }
};


export const updateUserRole = async (id, roleData) => {
  try {
    const response = await api.put(`mivulite/users/${id}/role`, roleData);
    return response.data;
  } catch (error) {
    console.error("Error updating user role:", error);
    throw error;
  }
};